<template>
  <div id="app">
    <div v-if="showToast" class="toast">
      <p>{{ toastText }}</p>
    </div>
  	<modals></modals>
  	<custom-header v-if="$utils.isLoggedIn()"></custom-header>
		<router-view :key="$route.fullPath"/>
  </div>
</template>
<script>
	import { bus } from '@/classes/bus'
	import { mapActions, mapState } from 'vuex'
	import Modals from '@/components/Modals'
	import CustomHeader from '@/components/CustomHeader'
	export default {
		name: 'app',
		computed: {
			...mapState('toasts', ['showToast', 'toastText'])
		},
		watch: {
			$route(){
				this.setRouter()
			}
		},
		created(){
			this.setRouter()
			this.listen()
			this.setSuperAdmin()
		},
		methods: {
			setRouter(){
				this.$network_utils.setRouter(this.$route)
			},
			listen(){
				bus.$on('logged_in', this.onLogin)
				window.addEventListener('mousemove', (event) => {
					this.setCursorX(event.clientX)
				})
			},
			setSuperAdmin(){
				if(!this.$utils.isLoggedIn()){
					return
				}
				this.$network_utils.getUser().then(response => {
					this.setSuperUser(response.is_super_admin)
				})
			},
			onLogin(){
				this.setSuperAdmin()
			},
			...mapActions('general', ['setSuperUser', 'setCursorX'])
		},
		components: {
			Modals,
			CustomHeader
		}
	}
</script>
<style>
	::-webkit-scrollbar {
	  width: 6px;
	  height: 6px;
	  margin-right: 30px;
	}
	::-webkit-scrollbar-track {
	  border-radius: 6px;
	}
	::-webkit-scrollbar-thumb {
	  background: var(--color-scrollbar);
	  border-radius: 6px;
	}
	:root {
	  --left-column-width: 220px;
	  --color-title: #104E8B;
	  --color-header: #104E8B;
	  --color-main: #104E8B;
	  --color-secondary: #ffb52b;
	  --color-text: #5c4846;
	  --color-button: #104E8B;
	  --color-button-text: white;
	}
	html,body {
		background-color: #F2F2F2;
		font-family: "Poppins", sans-serif;
		padding: 0;
		margin: 0;
	}
	textarea.field_error, input.field_error, .field_error input[type="date"], select.field_error{
		border: 1px solid;
		border-color: red !important;
	}
	.page-width{
		display: flex;
		align-items: center;
		max-width: 1600px;
		margin: 0 auto;
	}
	.toast {
	  direction: rtl;
	  min-width: 190px;
	  border-radius: 30px;
	  background-color: #333;
	  color: #fff;
	  text-align: center;
	  padding: 6px 24px;
	  position: fixed;
	  z-index: 10000000000;
	  left: 50%;
	  transform: translateX(-50%);
	  bottom: 50%;
	  -webkit-animation: toastshow 0.3s, toasthide 0.3s 1.8s;
	  animation: toastshow 0.3s, toasthide 0.3s 1.8s;
	}
	@-webkit-keyframes toastshow {
	  from {
	    bottom: 0;
	    opacity: 0;
	  }
	  to {
	    bottom: 50%;
	    opacity: 1;
	  }
	}
	@keyframes toastshow {
	  from {
	    bottom: 0;
	    opacity: 0;
	  }
	  to {
	    bottom: 50%;
	    opacity: 1;
	  }
	}
	@-webkit-keyframes toasthide {
	  from {
	    bottom: 50%;
	    opacity: 1;
	  }
	  to {
	    bottom: 0;
	    opacity: 0;
	  }
	}
	@keyframes toasthide {
	  from {
	    bottom: 50%;
	    opacity: 1;
	  }
	  to {
	    bottom: 0;
	    opacity: 0;
	  }
	}
	.red {
		color: red;
	}
	.white_space_pre_line{
		white-space: pre-line;
	}
	.break_word{
		word-break: break-word;
	}
	.uppercase{
		text-transform: uppercase;
	}
	.margin_0{
		margin: 0 !important;
	}
	.margin_right_0 {
		margin-right: 0 !important;
	}
	.unique-button-faded-border-left{
		padding-left: 10px;
		border-left: 1px solid rgba(0, 0, 0, 0.4);
	}
	.faded_bottom_border{
		padding-top: 10px;
		padding-bottom: 10px;
		border-bottom: 2px solid rgba(0, 0, 0, 0.1);
	}
	.faded{
		pointer-events: none;
 		opacity: 0.6;
	}
	.display_inline_block{
		display: inline-block;
	}
	.flex{
		display: flex;
	}
	.flex_wrap{
		flex-wrap: wrap;
	}
	.flex_direction_column{
		flex-direction: column;
	}
	.flex_justify_center{
		justify-content: center;
	}
	.flex_align_center{
		align-items: center;
	}
	.flex_justify_between {
	  justify-content: space-between !important;
	}
	.flex_align_start{
	  align-items: flex-start;
	}
	.flex_align_end{
	  align-items: flex-end;
	}
	.flex_align_self_bottom {
	  align-self: flex-end;
	}
	.flex_justify_end {
	  justify-content: flex-end;
	}
	.text_align_right{
		text-align: right;
	}
	.text_align_left{
		text-align: left;
	}
	.center_horizontal{
		left: 50%;
		transform: translateX(-50%);
	}
	.horizontal_space{
		width: 10px;
	}
	.vertical_space{
		height: 10px;
	}
	.card{
		border: 1px solid rgba(0, 0, 0, 0.2);
		padding: 10px;
		border-radius: 4px;
		box-shadow: 0 12px 18px 2px rgba(34,0,51,.04),0 6px 22px 4px rgba(7,48,114,.12),0 6px 10px -4px rgba(14,13,26,.12);
	}
	#right_column{
		position: relative;
		overflow: auto;
		float: right;
		width: calc(100% - var(--left-column-width));
		height: 100%;
	}
	.btn{
	  cursor: pointer;
	}
	.relative{
		position: relative;
	}
	.absolute {
	  position: absolute;
	}
	.loading {
	  height: 30px;
	  width: 30px;
	}
	.loading:after {
	  -webkit-animation: spinAround 0.6s infinite linear;
	  animation: spinAround 0.6s infinite linear;
	  border: 2px solid var(--color-main);
	  border-radius: 290486px;
	  border-right-color: transparent;
	  border-top-color: transparent;
	  content: "";
	  display: block;
	  height: 30px;
	  width: 30px;
	}
	.full_width{
		width: 100%;
	}
	@keyframes spinAround {
		from {
			transform: rotate(0)
		}
		to {
			transform: rotate(359deg)
		}
	}
	.bold{
		font-weight: 600;
	}
	.white{
		color: white;
	}
	.blue_text{
  	color: #3273dc;
	}
	.blue_text:hover{
  	color: #3273dc !important;
	}
	.form_section{
		margin-top: 20px;
	}
	input[type="range"] {
	  -webkit-appearance: none;
	  padding: 0 !important;
	  width: 100%;
	  height: 8px;
	  border-radius: 5px;
	  background: var(--color-main);
	  outline: none;
	  -webkit-transition: .2s;
	  transition: opacity .2s;
	}
	input[type="range"]::-webkit-slider-thumb {
	  outline: none;
	  border-color: transparent;
	  width: 20px;
	  height: 20px;
	  border-radius: 50%;
	  background: var(--color-header);
	  cursor: pointer;
	}
	input[type="range"]::-moz-range-thumb {
	  outline: none;
	  border-color: transparent;
	  width: 20px;
	  height: 20px;
	  border-radius: 50%;
	  background: var(--color-header);
	  cursor: pointer;
	}
	input {
		padding-left: 20px !important;
		border: none;
		border-radius: 30px;
		padding: 10px;
		font-size: 18px;
		color: var(--color-text);
	}
	textarea, .text_area {
	  padding: 10px;
	  border: 1px solid rgba(0, 0, 0, 0.1);
	  resize: none;
	  min-width: 420px;
	  min-height: 180px;
	}
	textarea:focus,
	input:focus {
	  outline: none;
	}
	input::-webkit-outer-spin-button,
	input::-webkit-inner-spin-button {
	  -webkit-appearance: none;
	  margin: 0;
	}
	input[type="time"],
	input[type="date"] {
	  background-color: #f2f2f2;
	  color: var(--color-text);
	}
	input[type='text']{
		border: 1px solid #bdc4c9;
		padding: 5px 6px;
		padding-left: 6px !important;
		margin: 2px 0 5px;
		margin-bottom: 5px;
		box-sizing: border-box;
		-webkit-appearance: none;
		font-size: 14px;
		font-weight: 400;
		border-radius: 4px;
	}
	select {
	  background: url("/black_down_arrow.svg") no-repeat right #ddd;
	  -webkit-appearance: none;
	  appearance: none;
	  background-size: 10px;
	  background-position-x: calc(100% - 10px);
	  border-radius: 30px;
	  border: 1px solid rgba(0, 0, 0, 0.1);
	  background-color: #f1f1f1;
	  min-width: 180px;
	  padding: 10px;
	}
	select[dir="ltr"]{
	  background-position-x: calc(100% - 10px);
	}
	select[dir="rtl"]{
	  background-position-x: 10px;
	}
	.modal_form{
	  padding-bottom: 30px;
	}
	.modal_footer {
		box-shadow: 0px 10px 30px -3px rgba(0, 0, 0, 0.75);
		direction: ltr;
		position: fixed;
		background-color: white;
		left: 0;
		border-bottom-left-radius: 6px;
		border-bottom-right-radius: 6px;
		bottom: -62px;
		display: flex;
		padding: 10px;
		margin: 0 !important;
		justify-content: flex-start;
		align-items: center;
		border-top: 1px solid var(--color-main);
		width: 100%;
		height: 70px;
	}
	.search_results {
	  position: relative;
	  background-color: var(--color-text);
	  color: white;
	  max-height: 300px;
	  overflow-x: hidden;
	  overflow-y: auto;
	}
	.search_result {
	  margin: 0;
	  padding: 10px;
	  cursor: pointer;
	  border-top: 1px solid white;
	}
	.custom_footer{
		width: 1300px;
		margin: 0 auto;
		margin-top: 40px;
		font-size: 10px;
		color: #999;
		text-align: left;
	}
	.is-orange{
		color: white;
		background-color: darkorange;
	}
	.is-orange:hover{
		color: white !important;
	}
	.is-orange.is-outlined{
		color: darkorange;
		border-color: darkorange;
		background-color: transparent;
	}
	.is-orange.is-outlined:hover{
		color: darkorange !important;
	}
	.is-red{
		color: white;
		background-color: red;
	}
	.is-red:hover{
		color: white !important;
	}
	.is-red.is-outlined{
		color: red;
		border-color: red;
		background-color: transparent;
	}
	.is-red.is-outlined:hover{
		color: red !important;
	}
	.is-green{
		color: white;
		background-color: green;
	}
	.is-green:hover{
		color: white !important;
	}
	.is-green.is-outlined{
		color: green;
		border-color: green;
		background-color: transparent;
	}
	.is-green.is-outlined:hover{
		color: green !important;
	}
	.unauthorized_file {
	  color: red !important;
	  pointer-events: none;
	}
	.file_error{
	  color: red !important;
	}
	.file_checkbox {
	  margin-left: 10px;
	}
	.file_link {
	  border-color: transparent;
	  border-radius: 18px;
	  border: none;
	  direction: rtl;
	  background-color: rgba(0, 0, 0, 0.18);
	  color: black;
	  margin-left: 10px;
	}
	.file_margin{
	  margin-bottom: 10px;
	}
	.file_link:after {
	  content: "←";
	}
	th{
	  text-transform: uppercase;
	}
	.table {
	  margin-bottom: 0;
	}
	.table tr.odd {
	  background-color: #f2f2f2;
	}
	.table thead th {
	  border-top: 0;
	  border-bottom-width: 1px;
	  font-family: "Poppins", sans-serif;
	  font-weight: 700;
	}
	.table thead th i {
	  margin-left: 0.325rem;
	}
	.table td,
	.table th {
	  vertical-align: middle;
	  font-size: 0.875rem;
	  line-height: 1.3;
	}
	.table {
	  width: 100%;
	  max-width: 100%;
	  margin-bottom: 1rem;
	  background-color: transparent;
	}
	.table th,
	.table td {
	  padding: 1rem;
	  /*vertical-align: top;*/
	  /*border-top: 1px solid #f3f3f3;*/
	}
	.table thead th {
	  text-align: left;
	  font-weight: 7 00;
	  vertical-align: bottom;
	}
	.table tbody + tbody {
	  border-top: 2px solid #f3f3f3;
	}
	.table .table {
	  background-color: #fff;
	}
	.outlined{
		border: 1px solid rgba(0, 0, 0, 0.1);
	}

	.m-0 {
  margin: 0 !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mr-0 {
  margin-right: 0 !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.ml-0 {
  margin-left: 0 !important;
}

.mx-0 {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mr-1 {
  margin-right: 0.25rem !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.ml-1 {
  margin-left: 0.25rem !important;
}

.mx-1 {
  margin-left: 0.25rem !important;
  margin-right: 0.25rem !important;
}

.my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mr-2 {
  margin-right: 0.5rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.ml-2 {
  margin-left: 0.5rem !important;
}

.mx-2 {
  margin-left: 0.5rem !important;
  margin-right: 0.5rem !important;
}

.my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

.m-3 {
  margin: 0.75rem !important;
}

.mt-3 {
  margin-top: 0.75rem !important;
}

.mr-3 {
  margin-right: 0.75rem !important;
}

.mb-3 {
  margin-bottom: 0.75rem !important;
}

.ml-3 {
  margin-left: 0.75rem !important;
}

.mx-3 {
  margin-left: 0.75rem !important;
  margin-right: 0.75rem !important;
}

.my-3 {
  margin-top: 0.75rem !important;
  margin-bottom: 0.75rem !important;
}

.m-4 {
  margin: 1rem !important;
}

.mt-4 {
  margin-top: 1rem !important;
}

.mr-4 {
  margin-right: 1rem !important;
}

.mb-4 {
  margin-bottom: 1rem !important;
}

.ml-4 {
  margin-left: 1rem !important;
}

.mx-4 {
  margin-left: 1rem !important;
  margin-right: 1rem !important;
}

.my-4 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

.m-5 {
  margin: 1.5rem !important;
}

.mt-5 {
  margin-top: 1.5rem !important;
}

.mr-5 {
  margin-right: 1.5rem !important;
}

.mb-5 {
  margin-bottom: 1.5rem !important;
}

.ml-5 {
  margin-left: 1.5rem !important;
}

.mx-5 {
  margin-left: 1.5rem !important;
  margin-right: 1.5rem !important;
}

.my-5 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}

.m-6 {
  margin: 3rem !important;
}

.mt-6 {
  margin-top: 3rem !important;
}

.mr-6 {
  margin-right: 3rem !important;
}

.mb-6 {
  margin-bottom: 3rem !important;
}

.ml-6 {
  margin-left: 3rem !important;
}

.mx-6 {
  margin-left: 3rem !important;
  margin-right: 3rem !important;
}

.my-6 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}

.m-auto {
  margin: auto !important;
}

.mt-auto {
  margin-top: auto !important;
}

.mr-auto {
  margin-right: auto !important;
}

.mb-auto {
  margin-bottom: auto !important;
}

.ml-auto {
  margin-left: auto !important;
}

.mx-auto {
  margin-left: auto !important;
  margin-right: auto !important;
}

.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}
</style>
 